import React from 'react';
import featureEnabled from 'shared/helper/feature';
import PaddleOverlayButton from '../../PaddleOverlayButton';
import PaddleBillingOverlayButton from '../../PaddleBillingOverlayButton';
var PaddleCheckoutButton = function PaddleCheckoutButton(_ref) {
  var paddlePlanId = _ref.paddlePlanId,
    onClose = _ref.onClose,
    onClick = _ref.onClick,
    className = _ref.className,
    children = _ref.children,
    upgradedFromSubscriptionId = _ref.upgradedFromSubscriptionId;
  if (!paddlePlanId) {
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: className,
      disabled: true
    }, children);
  }
  var CheckoutButton = featureEnabled('curie_use_paddle_billing_for_new_subscriptions') ? PaddleBillingOverlayButton : PaddleOverlayButton;
  return /*#__PURE__*/React.createElement("div", {
    onClickCapture: onClick
  }, /*#__PURE__*/React.createElement(CheckoutButton, {
    paddlePlanId: paddlePlanId,
    onClose: onClose,
    buttonClassName: className,
    upgradedFromSubscriptionId: upgradedFromSubscriptionId
  }, children));
};
export default PaddleCheckoutButton;